import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { FaBan, FaRobot, FaServer, FaStethoscope } from 'react-icons/fa';
import { Reveal } from '../motion/Reveal';
import MagicCard from './ui/MagicCard';
import { useInViewActive, useLoop, useReducedMotionPref, clamp } from '../../utils/loop';

const ICONS = [FaBan, FaStethoscope, FaRobot, FaServer];

/** A6 honest limits — Magic Cards + icon breathe (21st.dev). */
const HomeLimits = () => {
  const { t } = useTranslation();
  const a = t('home.limits', { returnObjects: true }) || {};
  const items = Array.isArray(a.items) ? a.items : [];
  const rootRef = useRef(null);
  const active = useInViewActive(rootRef);
  const reduced = useReducedMotionPref();
  const clock = useLoop(8, 1, active && !reduced);

  return (
    <section className="home-odam-section home-odam-section--white" id="limits" ref={rootRef}>
      <div className="container">
        <Reveal>
          <h2 className="home-odam-h2">{a.title}</h2>
        </Reveal>
        <div className="home-odam-limits">
          {items.map((it, i) => {
            const Icon = ICONS[i] || FaBan;
            const ph = (((clock / 8 - i / 4) % 1) + 1) % 1;
            const g = reduced ? 0 : Math.sin(Math.PI * clamp(ph * 4));
            return (
              <Reveal key={i} delay={0.04 * i}>
                <MagicCard
                  className="home-limits-card"
                  gradientFrom="#99f6e4"
                  gradientTo="#0891b2"
                  gradientColor="#ecfeff"
                >
                  <div className="home-limits-card__inner">
                    <span
                      className="home-limits-card__icon"
                      aria-hidden="true"
                      style={{
                        boxShadow: `0 0 0 ${6 * g}px rgba(8,145,178,${0.12 * g})`
                      }}
                    >
                      <Icon />
                    </span>
                    <div>
                      <h3>{it.t}</h3>
                      <p dangerouslySetInnerHTML={{ __html: it.d || '' }} />
                    </div>
                  </div>
                </MagicCard>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HomeLimits;
